import {styled} from 'styled-components';
import {Table, TableColumnsType} from 'antd';
import {columnsBookingReport} from './columns';

interface TableData {
    key: React.Key;
    SUM: number;
    CURRENCYTYPE?: string;
    CURRENCY?: string;
    ORIGINALSUN?: number;
    SHIFTDATE?: string;
    nested?: TableData[];
}

const columns: TableColumnsType<TableData> = columnsBookingReport;

const BookingReportTable = ({dataValues, loading}) => {
    return (
        <StyledTable>
            <Table
                pagination={false}
                dataSource={dataValues}
                loading={loading}
                columns={columns}
                size="small"
                // tableLayout="fixed" // Устанавливаем фиксированный макет таблицы
                summary={(pageData) => {
                    let sumAccept = 0;
                    let sumDecline = 0;
                    let sumRequest = 0;
                    let sumAmount = 0;
                    pageData.forEach(
                        ({
                            totalAccept,
                            totalDecline,
                            totalRequest,
                            totalAmount,
                        }: any) => {
                            sumAccept += totalAccept;
                            sumDecline += totalDecline;
                            sumRequest += totalRequest;
                            sumAmount += totalAmount;
                        }
                    );

                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0}>
                                    Всего
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumAccept)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU', {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1,
                                        }).format(
                                            Number(
                                                (sumAccept / sumAmount) * 100
                                            )
                                        )}{' '}
                                        %
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumDecline)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU', {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1,
                                        }).format(
                                            Number(
                                                (sumDecline / sumAmount) * 100
                                            )
                                        )}{' '}
                                        %
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumRequest)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU', {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1,
                                        }).format(
                                            Number(
                                                (sumRequest / sumAmount) * 100
                                            )
                                        )}{' '}
                                        %
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumAmount)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                rowClassName={() => 'main-row'}
            />
        </StyledTable>
    );
};

export default BookingReportTable;

const StyledTable = styled.div`
    .ant-table-thead > tr > th {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: center;
        /* padding: 0 !important; // Убираем внутренние отступы заголовков */
        height: 45px; // Устанавливаем высоту строки заголовка
        line-height: 17px; // Устанавливаем высоту строки для текста заголовка
    }

    .ant-table-row-expand-icon-cell {
        width: 20px !important; // Устанавливаем фиксированную ширину для колонки значка раскрытия
    }

    .ant-table-expanded-row {
        & > td {
            padding-left: 30px !important; // Убираем отступ
            padding-right: 0 !important; // Убираем отступ
        }
    }
    .ant-table-layout-fixed {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .ant-table-footer {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: left;
    }

    table > tbody > tr > td {
        background-color: #ffffff;
        font-family: Inter;
        border: 1px solid #efefef;
        color: #333333;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.8px;
        text-align: left;
        /* padding: 0 !important; // Убираем внутренние отступы ячеек */
        height: 17px; // Устанавливаем высоту строки
        line-height: 17px; // Устанавливаем высоту строки для текста
    }

    .ant-table-summary {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: left;
        tr > td:first-child {
            border-bottom-left-radius: 8px;
        }

        tr > td:last-child {
            border-bottom-right-radius: 8px;
        }
    }

    .ant-table-thead > tr > th {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: left;
    }

    .ant-table-footer {
        background-color: #9481cd40;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: left;
    }

    table > tbody > tr > td {
        background-color: #ffffff;
        font-family: Inter;
        border: 1px solid #efefef;
        color: #333333;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.8px;
        text-align: left;
        height: 30px;
    }
`;

const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
`;
